module.exports = __webpack_public_path__ + "img/examples-en-9.f30f7005.jpg";